import { Schema as S } from "effect";

/**
 * Statutory Insurer Schema
 *
 * Represents an entry from the Kostenträgerdatei.
 * May be a card IK (type 01) that links to a cost carrier (type 02).
 */
export const StatutoryInsurerSchema = S.Struct({
  /** Institutionskennzeichen (9-digit identifier) */
  iknr: S.String,
  /** Official insurer name */
  name: S.String,
  /** Common abbreviation (e.g., TK, AOK) */
  shortName: S.optional(S.String),
  /** Phone number for patient contact */
  phone: S.optional(S.String),
  /** If this is a card IK, the linked cost carrier's IK */
  costCarrierIknr: S.optional(S.String),
  /** If this is a card IK, the linked cost carrier's name */
  costCarrierName: S.optional(S.String),
});

export type StatutoryInsurer = S.Schema.Type<typeof StatutoryInsurerSchema>;

/**
 * Search Insurers Response Schema
 *
 * Returns list of matching statutory insurers.
 */
export const SearchInsurersResponseSchema = S.Array(StatutoryInsurerSchema);

export type SearchInsurersResponse = S.Schema.Type<
  typeof SearchInsurersResponseSchema
>;
